export default "__VITE_ASSET__DBAIsgEN__"